import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  Glyphicon,
  FormGroup,
  ControlLabel,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-exercises.css'
import '../../statics/css/table-data-exercises.css'
import '../../statics/css/util.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { exercisesByCategoryList, exercisesList } from '../../dao-firebase/training-daofirebae'

class TableDataExercises extends Component {

  constructor(props) {
    super(props);

    this.state = {

      exercises: [],

    };

  }

  componentDidMount() {

  }

  componentWillMount() {

  }

  onInputChange(e, index) {

    //console.log(target);

    let value = e.target.value;
    let name = e.target.name;
    console.log("value: " + value)
    if (name.includes("_series_input")) {
      this.props.exercises[index].data.infos.series = value;
    } else if (name.includes("_repetitions_input")) {
      this.props.exercises[index].data.infos.repeatitions = value;
    } else if (name.includes("_charge_input")) {
      this.props.exercises[index].data.infos.charge = value;
    } else if (name.includes("_cadence_input")) {
      this.props.exercises[index].data.infos.cadence = value;
    } else if (name.includes("_inter_input")) {
      this.props.exercises[index].data.infos.inter = value;
    } else if (name.includes("_obs_input")) {
      this.props.exercises[index].data.infos.obs = value;
    }

    this.props.handleUpdateExercisesState(this.props.exercises, false);

  }

  saveExerciseData(index) {
    this.props.exercises[index].data.infos.editing = false;
    this.props.handleUpdateExercisesState(this.props.exercises, false);
  }

  editExerciseData(index) {
    this.props.exercises[index].data.infos.editing = true;
    this.props.handleUpdateExercisesState(this.props.exercises, false);
  }

  removeExerciseData(index) {
    //Remove-se o elemento do index, o segundo parâmetro é o número
    //de elementos a serem removidos
    this.props.exercises.splice(index, 1);
    //this.props.exercises[index].data.infos.editing = true;
    this.props.handleUpdateExercisesState(this.props.exercises, true);
  }

  upExercise(index) {

    //Caso seja undefined quer dizer que foi de um botão desabilitado
    if (index) {
      //Reduzindo a posicao do exercício em questão (subindo o exercicio)
      this.props.exercises[index].data.infos.position_in_section = this.props.exercises[index].data.infos.position_in_section - 1;
      //O exercício de cima deve descer [index - 1], soma-se 1 no position dele
      this.props.exercises[index - 1].data.infos.position_in_section = this.props.exercises[index - 1].data.infos.position_in_section + 1;

      this.props.handleUpdateExercisesState(this.props.exercises, false);
    }
  }

  downExercise(index) {

    //console.log("INDEX DOWN: " + index);

    //Caso seja undefined quer dizer que foi de um botão desabilitado
    if (index == 0 || index) {
      //Aumentando a posicao do exercício em questão (descendo o exercicio)
      this.props.exercises[index].data.infos.position_in_section = this.props.exercises[index].data.infos.position_in_section + 1;
      //O exercício de cima deve descer [index + 1], subtrai-se 1 no position dele
      this.props.exercises[index + 1].data.infos.position_in_section = this.props.exercises[index + 1].data.infos.position_in_section - 1;

      this.props.handleUpdateExercisesState(this.props.exercises, false);
    }
  }

  renderExercises() {

    let lastCategory = '';

    let exerciseItems = [];

    //Sort by position_in_section
    this.props.exercises.sort((a, b) => (a.data.infos.position_in_section > b.data.infos.position_in_section) ? 1 : ((b.data.infos.position_in_section > a.data.infos.position_in_section) ? -1 : 0));

    //console.log("MAP: " + this.props.allExercisesMap);

    if (this.props.exercises) {

      //console.log("NOS DATAS: " + this.props.exercises);
      let sizeExercises = this.props.exercises.length;
      for (let i = 0; i < sizeExercises; i++) {

        let exercise = this.props.exercises[i];

        // if (exercise.data.category != lastCategory) {

        //   lastCategory = exercise.data.category;
        //   exerciseItems.push(
        //     <tr className="item-exercises-category">

        //       <td className="exercise-category">
        //         <p>{exercise.data.category}</p>
        //       </td>

        //     </tr>
        //   )
        // }

        //console.log(exercise.data.name + " INCLUDES: " + this.props.search + "? " + exercise.data.name.includes(this.props.search))

        //console.log("EXERCISE: " + JSON.stringify(exercise));
        if (this.props.allExercisesMap[exercise.id]) {
          exerciseItems.push(
            <tr className="item-exercises-list">

              <td className="data-exercise-td exercise-name middle-td" id={JSON.stringify(exercise.data)}>
                <div className="exercise-name-inner-div">
                  <If test={this.props.editable}>
                    <div className="position-buttons">
                      {/* Condição no onclick: só pode ser clicado o up caso não seja o primeiro item */}
                      <Glyphicon onClick={(i != 0 ? () => { this.upExercise(i) } : () => { this.upExercise(undefined) })} className={`action-exercise action-exercise-position up-data-exercise ${i == 0 ? 'disable-icon' : ''}`} glyph="arrow-up" />
                      {/* Condição no onclick: só pode ser clicado o down caso não seja o último item */}
                      <Glyphicon onClick={(i != (sizeExercises - 1) ? () => { this.downExercise(i) } : () => { this.downExercise(undefined) })} className={`action-exercise action-exercise-position down-data-exercise ${i == (sizeExercises - 1) ? 'disable-icon' : ''}`} glyph="arrow-down" />
                    </div>
                  </If>
                  <p>{this.props.allExercisesMap[exercise.id].name}</p>
                </div>
              </td>
              <td className="text-bold data-exercise-td exercise-series middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl
                    name={exercise.id + "_series_input"}
                    type="text"
                    value={exercise.data.infos.series}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>

                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size text-bold color-primary no-m-bottom text-center">{exercise.data.infos.series == "" ? "-" : exercise.data.infos.series}</p>
                </If>
              </td>
              <td className="text-bold data-exercise-td exercise-repeatitions middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl

                    name={exercise.id + "_repetitions_input"}
                    type="text"
                    value={exercise.data.infos.repeatitions}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>
                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size text-bold color-primary no-m-bottom text-center">{exercise.data.infos.repeatitions == "" ? "-" : exercise.data.infos.repeatitions}</p>
                </If>
              </td >
              <td className="text-bold data-exercise-td exercise-charge middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl

                    name={exercise.id + "_charge_input"}
                    type="text"
                    value={exercise.data.infos.charge}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>
                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size text-bold color-primary no-m-bottom text-center">{exercise.data.infos.charge == "" ? "-" : exercise.data.infos.charge}</p>
                </If>
              </td >
              <td className="text-bold data-exercise-td exercise-cadence middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl
                    name={exercise.id + "_cadence_input"}
                    type="text"
                    value={exercise.data.infos.cadence}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>
                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size text-bold color-primary no-m-bottom text-center">{exercise.data.infos.cadence == "" ? "-" : exercise.data.infos.cadence}</p>
                </If>
              </td >
              <td className="text-bold data-exercise-td exercise-inter middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl

                    name={exercise.id + "_inter_input"}
                    type="text"
                    value={exercise.data.infos.inter}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>
                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size text-bold color-primary no-m-bottom text-center">{exercise.data.infos.inter == "" ? "-" : exercise.data.infos.inter}</p>
                </If>
              </td >
              <td className="data-exercise-td exercise-obs middle-td">
                <If test={exercise.data.infos.editing}>
                  <FormControl

                    name={exercise.id + "_obs_input"}
                    type="text"
                    value={exercise.data.infos.obs}
                    onChange={(e) => this.onInputChange(e, i)} />
                </If>

                <If test={!exercise.data.infos.editing}>
                  <p className="normal-size color-primary no-m-bottom text-center">{exercise.data.infos.obs == "" ? "-" : exercise.data.infos.obs}</p>
                </If>
              </td>

              <If test={this.props.editable}>
                <td className="data-exercise-td exercise-actions text-center middle-td">

                  <If test={!exercise.data.infos.editing}>
                    <Glyphicon className="action-exercise edit-data-exercise" glyph="pencil" onClick={() => this.editExerciseData(i)} />
                    <Glyphicon className="action-exercise remove-data-exercise" glyph="remove" onClick={() => this.removeExerciseData(i)} />
                  </If>
                  <If test={exercise.data.infos.editing}>
                    <Glyphicon className="action-exercise ok-data-exercise" glyph="ok" onClick={() => this.saveExerciseData(i)} />
                  </If>
                </td>
              </If>
            </tr >
          );
        } else {
          console.log(exercise.data);
          exerciseItems.push(
            <tr className="item-exercises-list">
              <td>
                <p>ERRO: {this.props.section}</p>
              </td>
            </tr>
          )
        }

      }


    }

    return exerciseItems;

  }

  render() {

    return (
      <div>
        <Table className={this.props.customClass ? this.props.customClass : ""} responsive>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Séries</th>
              <th>Repetições</th>
              <th>Carga</th>
              <th>Cadência</th>
              <th>Intervalo</th>
              <th>Observação</th>
              <If test={this.props.editable}>
                <th>Ações</th>
              </If>
            </tr>
          </thead>
          <tbody>
            {this.renderExercises()}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default TableDataExercises;



// WEBPACK FOOTER //
// src/components/treinos/table-data-exercises.js